import { useEffect, useState } from 'react';
import { BASE_PHONE, GREEN_FILLED_CIRCLE_PULSING, GREEN_FILLED_CIRCLE, EMPTY_CIRCLE, SOLID_CROSS } from 'navigation-components/config';
import { capabilities } from 'navigation-components/capabilities';
import { useInvokeCapability } from 'navigation-components/consumer/hooks';
import { CallWidgetStates } from 'calling-internal-common/widget-status/constants/CallWidgetStates';
import { useThirdPartyWidgetDetailsContext } from 'calling-remote-common/context/ThirdPartyWidgetDetailsContext';
import { getShouldShowActiveCallState } from 'calling-internal-common/widget-status/operators/getCallState';
import { useUserInfo } from 'calling-ui-library/user-info/context/UserInfoContext';
export const useUpdateThirdPartyCallIcon = ({
  isLoading,
  supportsCallingWindow,
  hasThirdPartyOpened
}) => {
  const [context] = useThirdPartyWidgetDetailsContext();
  const {
    thirdPartyCallStatus,
    thirdPartyIsLoggedIn,
    thirdPartyUserAvailable,
    thirdPartyIsPopupOpen
  } = context;
  const {
    gates
  } = useUserInfo();
  const [iconStatus, setIconStatus] = useState(BASE_PHONE);
  const updateIcon = useInvokeCapability(capabilities.UPDATE_CALL_ICON_STATUS_CAP);
  useEffect(() => {
    updateIcon({
      status: iconStatus
    });
  }, [iconStatus, updateIcon]);
  useEffect(() => {
    if (supportsCallingWindow && !thirdPartyIsPopupOpen) {
      setIconStatus(SOLID_CROSS);
      return;
    }
    if (isLoading || !thirdPartyIsLoggedIn) {
      setIconStatus(BASE_PHONE);
      return;
    }
    const userIsReady = thirdPartyIsLoggedIn && thirdPartyUserAvailable;
    if (userIsReady || getShouldShowActiveCallState(thirdPartyCallStatus)) {
      const isOutboundCallInProgress = thirdPartyCallStatus === CallWidgetStates.INITIALIZING_OUTBOUND_CALL;
      const isInboundCallInProgress = thirdPartyCallStatus === CallWidgetStates.INCOMING_INBOUND_CALL;
      const isCallInProgress = thirdPartyIsLoggedIn && isOutboundCallInProgress || userIsReady && isInboundCallInProgress || thirdPartyCallStatus === CallWidgetStates.ANSWERED;
      if (isCallInProgress) {
        setIconStatus(GREEN_FILLED_CIRCLE_PULSING);
      } else {
        setIconStatus(GREEN_FILLED_CIRCLE);
      }
      return;
    }
    setIconStatus(EMPTY_CIRCLE);
  }, [gates, isLoading, thirdPartyCallStatus, thirdPartyIsLoggedIn, thirdPartyUserAvailable, updateIcon, thirdPartyIsPopupOpen, supportsCallingWindow, hasThirdPartyOpened]);
};